export const formatted = text => (text || '').replace(/\\n/g, '\n')